import { TermsConditionsStyled } from './TermsAndConditions.styled'

export const TermsAndConditions = () => {
  return (
    <TermsConditionsStyled>
    <h1>TÉRMINOS Y CONDICIONES DE USO</h1>
    <p><strong>CashBackColombia.com</strong></p>
    <p><em>(Vigentes a partir de Octubre 21, 2025)</em></p>

    <p>
      Los presentes Términos y Condiciones (en adelante, los “Términos”)
      rigen la relación entre <strong>Cash Back Colombia S.A.S.</strong>,
      sociedad debidamente constituida bajo las leyes de la República de
      Colombia, identificada con NIT 901.556.175-5 y con domicilio en Bogotá
      D.C. (en adelante, “CashBackColombia.com”, “CBC”, o “nosotros”), y
      cualquier Usuario que se registre y utilice la plataforma
      CashBackColombia.com o sus servicios relacionados (en adelante, el
      “Usuario” o “Consumidor”).
    </p>

    <p>
      Al registrarse, acceder o utilizar los servicios ofrecidos a través de
      CashBackColombia.com, el Usuario declara expresamente que ha leído,
      entendido y aceptado estos Términos en su totalidad y se compromete a
      cumplirlos de conformidad con la ley colombiana.
    </p>

    <h2>1. OBJETO Y ACEPTACIÓN</h2>
    <p>
      CashBackColombia.com proporciona un servicio de recompensas tipo cash
      back (dinero de vuelta) que permite a los Usuarios obtener un
      porcentaje de sus compras realizadas en Comercios Participantes. Al
      adherirse y utilizar la plataforma, el Usuario autoriza a CBC a
      procesar y utilizar sus datos personales y de compra estrictamente
      para los fines de administrar y operar el sistema de cash back.
    </p>
    <p>
      El Usuario reconoce y acepta que CashBackColombia.com no vende,
      transfiere ni comparte datos personales con terceros, excepto cuando
      sea requerido por ley o sea estrictamente necesario para procesar los
      pagos a través de canales financieros autorizados y seguros.
    </p>

    <h2>2. FUNCIONAMIENTO DE CASHBACKCOLOMBIA.COM</h2>
    <ul>
      <li>
        <strong>Registro:</strong> El Usuario se registra a través de
        WhatsApp utilizando el sistema QuickerBot, suministrando la
        información personal necesaria para su identificación y procesamiento
        de pagos.
      </li>
      <li>
        <strong>Realización de una Compra:</strong> El Usuario realiza una
        compra calificada en cualquier Comercio Participante.
      </li>
      <li>
        <strong>Carga del Comprobante de Compra:</strong> El Usuario sube una
        foto de la factura o comprobante de compra a través del sistema
        QuickerBot para registrar la transacción en su cuenta.
      </li>
      <li>
        <strong>Cash Back Pendiente:</strong> Una vez validada la factura, el
        Usuario verá reflejado en su cuenta un monto como “Cash Back
        Pendiente”.
      </li>
      <li>
        <strong>Solicitud de Retiro (Cash Out):</strong> Después de que el
        Usuario acumule al menos COP $50.000 en Cash Back confirmado, podrá
        solicitar un retiro, que será procesado de acuerdo con el cronograma
        de pagos descrito a continuación.
      </li>
    </ul>

    <h2>3. PAGOS DE CASH BACK</h2>
    <p>
      <strong>Método de Pago:</strong> CashBackColombia.com procesará todos
      los pagos a consumidores utilizando PSE (Pagos Seguros en Línea), en
      cumplimiento con la normativa colombiana de seguridad financiera y de
      datos.
    </p>
    <p>
      <strong>Cronograma de Pago:</strong> El Cash Back ganado y validado se
      pagará el día 15 de cada mes, correspondiente al Cash Back total
      acumulado durante el mes anterior.
    </p>
    <p>
      <strong>Condición de Pago:</strong> Los pagos de Cash Back solo se
      realizarán después de que el Comercio correspondiente haya pagado el
      monto aplicable a CashBackColombia.com.
    </p>
    <p>
      <strong>Monto Mínimo de Retiro:</strong> El Cash Back solo se pagará
      una vez que el saldo confirmado del Usuario alcance los COP $50.000.
    </p>

    <h2>4. TÉRMINOS Y DEFINICIONES</h2>
    <ul>
      <li>
        <strong>Compra Calificada:</strong> Transacción verificada en un
        Comercio Participante.
      </li>
      <li>
        <strong>Comercio Participante:</strong> Negocio con acuerdo válido y
        activo con CashBackColombia.com.
      </li>
      <li>
        <strong>Cash Back Pendiente:</strong> Monto mostrado mientras se
        valida la compra.
      </li>
      <li>
        <strong>Cash Back Confirmado:</strong> Monto aprobado y confirmado
        para pago.
      </li>
    </ul>

    <h2>5. USO DE DATOS PERSONALES</h2>
    <p>
      CashBackColombia.com, como Responsable del Tratamiento, recolecta y
      procesa datos personales y transaccionales únicamente para administrar
      el programa Cash Back.
    </p>
    <ul>
      <li>Información de identificación del Usuario.</li>
      <li>Datos de compra y gasto necesarios para el cálculo del Cash Back.</li>
      <li>
        Información de pago requerida para las transferencias por PSE.
      </li>
    </ul>
    <p>
      <strong>Consentimiento:</strong> Al unirse y utilizar la plataforma, el
      Usuario otorga a CBC autorización explícita para:
    </p>
    <ul>
      <li>Recolectar, almacenar, procesar y analizar datos personales y de compra.</li>
      <li>Utilizar dichos datos exclusivamente para la operación del programa Cash Back.</li>
      <li>Retener tales datos por el período necesario para cumplir con obligaciones legales.</li>
    </ul>
    <p>
      CashBackColombia.com cumple plenamente con la Ley 1581 de 2012, el
      Decreto 1377 de 2013 y demás leyes aplicables de protección de datos en
      Colombia. Los Usuarios pueden ejercer sus derechos ARCO contactando a
      CBC a través de <a href="mailto:info@cashbackcolombia.com">info@cashbackcolombia.com</a>.
    </p>

    <h2>6. RESPONSABILIDADES Y LIMITACIONES</h2>
    <p>
      CBC es responsable de gestionar la plataforma, verificar las compras
      elegibles y procesar los pagos de acuerdo con estos Términos. CBC no es
      responsable por caídas del sistema, fallas de red o eventos de fuerza
      mayor que afecten temporalmente el acceso a la plataforma.
    </p>
    <p>
      Los Usuarios son responsables de garantizar la exactitud de su
      información de contacto y bancaria. CBC no será responsable por pagos
      fallidos debido a datos inexactos proporcionados por el Usuario.
    </p>

    <h2>7. MODIFICACIONES</h2>
    <p>
      CashBackColombia.com se reserva el derecho de modificar estos Términos
      y Condiciones en cualquier momento. Las versiones actualizadas se
      publicarán en www.cashbackcolombia.com, y el uso continuado de la
      plataforma constituye aceptación de los nuevos términos.
    </p>

    <h2>8. LEY APLICABLE Y JURISDICCIÓN</h2>
    <p>
      Estos Términos se regirán por las leyes de la República de Colombia. 
      Cualquier disputa será resuelta por los tribunales competentes de Bogotá D.C., Colombia.
    </p>

    <p style={{ marginTop: "30px" }}>
      <strong>Cash Back Colombia S.A.S.</strong> <br />
      NIT 901.556.175-5 <br />
      Carrera 16 #93-78, Oficina 301 Bogotá D.C., Colombia <br />
      📧 <a href="mailto:support@cashbackcolombia.com">support@cashbackcolombia.com</a>
    </p>
  </TermsConditionsStyled>
  )
}
